module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("lHGlI"))).then(() => parcelRequire('37nVf'));